import subjectType from "./subjectType";
 
 //subject 
 export const successFetchedSubject =(data)=>({
    type: subjectType.SUCCESS_FETCHIED_SUBJECT,
    payload: data
     })
    export const failureFetchedSubject =(data)=>({
    type: subjectType.FAILURE_FETCHED_SUBJECT,
    payload: data
     })
    
